import React from "react";

const FloorplanSVG = React.forwardRef((props, ref) => (
  <svg
    ref={ref}
    width="2360"
    height="1640"
    viewBox="0 0 2360 1640"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="122" y="485" width="474" height="759" fill="#E601FF" />
    <rect x="596" y="605" width="391" height="639" fill="#3CFE02" />
    <path d="M1250 924H1111V605H596V485H1250V924Z" fill="#0A02FF" />
    <path d="M1780 456V802H1632V1111H1250V493H1299V456H1780Z" fill="#FE7902" />
    <path d="M1780 1244H1250V1111H1633V803H1780V1244Z" fill="#B402FE" />
    <path d="M2114 697H2260V860H1780V456H2114V697Z" fill="#02CEFF" />
  </svg>
));

export default FloorplanSVG;